import React, { useState } from 'react';
// import * as Collapsible from '@radix-ui/react-collapsible';
import ReactPlayer from 'react-player';
import { ReactDrawer } from '@parts';
// import { useMediaQuery } from 'react-responsive';
import { useMount } from 'ahooks';

const removeHtmlComments = (str) => {
  // Regular expression to match HTML comments
  const commentRegex = /<!--[\s\S]*?-->/g;
  // Replace comments with an empty string
  return str.replace(commentRegex, '');
};

const CollapsibleItem = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div className="ProductAccordion__item">
      <div
        className="ProductAccordion__item__trigger"
        onClick={handleClick}
        tabIndex={0}
        onKeyUp={(ev) => {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            handleClick();
          }
        }}
      >
        <h6>{title}</h6>
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use href="#close"></use>
        </svg>
      </div>
      {open && <div className="ProductAccordion__item__content">{children}</div>}
    </div>
  );
};

const ProductInfo = (props) => {
  const { product, mainProdApplication, ctx, specsData } = props;
  const [showMeasurementsDrawer, setShowMeasurementsDrawer] = useState(false);

  useMount(() => {
    ctx.on('openMeasureGuide', () => {
      setShowMeasurementsDrawer(true);
    });
  });

  const shippingLabel = () => {
    if (specsData && product.type == 'Custom') {
      return (
        <div className="shippingLabel">
          <p className="estimate">
            Custom products are made to order and are estimated to arrive in 7-10 weeks. (
            <a href="/pages/production-shipping-times">Shipping</a>)
          </p>
          <p className="warranty">
            All products are covered with our manufacturing warranty.(<a href="/pages/returns-warranty">Warranty</a>)
          </p>
        </div>
      );
    } else {
      return (
        <div className="shippingLabel">
          <p>
            Non-custom products are estimated to arrive in 5-8 business days. (<a href="/pages/production-shipping-times">Shipping</a>){' '}
            <br />
            All products are covered with our manufacturing warranty. (<a href="/pages/returns-warranty">Warranty</a>)
          </p>
        </div>
      );
    }
  };

  let customProduct =
    mainProdApplication === 'Drawer Organizers' || mainProdApplication === 'Medical Drawer Organizers' || product.type == 'Custom';
  let valuePropsQualifier = customProduct || product.type == 'Office Product' ? 'custom' : 'standard';

  return (
    <>
      <ul className="Product__valueProposition">
        {valuePropsQualifier == 'custom' ? (
          <>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#compartments"></use>
                </svg>
              </figure>
              <figcaption>Premium Acrylic</figcaption>
            </li>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#scratch"></use>
                </svg>
              </figure>
              <figcaption>Scratch Resistant</figcaption>
            </li>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#bpa"></use>
                </svg>
              </figure>
              <figcaption>BPA Free + Non-Toxic</figcaption>
            </li>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#microbial"></use>
                </svg>
              </figure>
              <figcaption>Anti-Microbial</figcaption>
            </li>
          </>
        ) : (
          <>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#customized"></use>
                </svg>
              </figure>
              <figcaption>Custom and Handcrafted</figcaption>
            </li>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#hearth"></use>
                </svg>
              </figure>
              <figcaption>Premium Quality</figcaption>
            </li>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#giveback"></use>
                </svg>
              </figure>
              <figcaption>Give Back</figcaption>
            </li>
            <li>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#eco"></use>
                </svg>
              </figure>
              <figcaption>Sustainably Sourced</figcaption>
            </li>
          </>
        )}
      </ul>
      <div className="ProductAccordion">
        {Boolean(removeHtmlComments(product.description)) && (
          <CollapsibleItem title="Description">
            <div className="ProductMain__description" dangerouslySetInnerHTML={{ __html: product.description }}></div>
          </CollapsibleItem>
        )}
        {customProduct && (
          <CollapsibleItem title="How to Measure">
            <div className="measurement-instructions">
              <figure className="video-guide" id="how-to-measure-guide" role="none">
                <ReactPlayer
                  className="media-player"
                  url={'https://cdn.shopify.com/videos/c/o/v/9dec9a3b333048849c7ac7665c71d0e6.mp4'}
                  // playing={playing}
                  width="100%"
                  height="100%"
                  controls={true}
                  light={
                    '//salt-by-sabrina-store.myshopify.com/cdn/shop/files/measuringdrawers-sabrina-pantry-03192024-WH-2aweb.jpg?v=1711392696&width=500'
                  }
                  onClick={() => this.setState({ playing: true })}
                  config={{
                    youtube: {
                      playerVars: {
                        modestbranding: 1,
                        showinfo: 0,
                      },
                    },
                    vimeo: {
                      playerOptions: {
                        responsive: true,
                      },
                    },
                  }}
                />
              </figure>
              <p className="small">
                <strong>IMPORTANT:</strong> Measure the <strong>INSIDE</strong> of the drawer box and <strong>ROUND DOWN</strong> to the
                nearest ½ inch increment. If your measurements are close to or exactly on the inch or ½ inch, round down to the nearest inch
                or ½ inch to ensure a proper fit. Be sure to consider any exposed hardware or screws and the overhang of the counter or
                desktop and round down accordingly.
              </p>
              {(product.title == 'Ellie' || product.title == 'Ana') && (
                // Ellie and Ana products need space behind for the power plugs
                <p className="small">
                  <div>
                    <strong>Measuring:</strong> In order to make room for outlet plugs at the back of the drawer, configure your
                    {` ${product.title} `} organizer length 1.5-2 inches less than the length of the drawer to the nearest half inch so that
                    they will fit with the organizer.
                  </div>
                </p>
              )}
              <button className="button" data-style="dark text" onClick={() => setShowMeasurementsDrawer(true)}>
                Learn More
              </button>
            </div>
          </CollapsibleItem>
        )}
        <ReactDrawer
          className={'layout-big'}
          showDrawer={showMeasurementsDrawer}
          setShowDrawer={setShowMeasurementsDrawer}
          position={'right'}
        >
          <div className="measurement-instructions-drawer">
            <header className="Drawer__header">
              <h4>How to Measure</h4>
              <button onClick={() => setShowMeasurementsDrawer(false)}>
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#close"></use>
                </svg>
              </button>
            </header>
            <figure className="video-guide" role="none">
              <ReactPlayer
                className="media-player"
                url={'https://cdn.shopify.com/videos/c/o/v/9dec9a3b333048849c7ac7665c71d0e6.mp4'}
                // playing={playing}
                width="100%"
                height="100%"
                controls={true}
                light={
                  '//salt-by-sabrina-store.myshopify.com/cdn/shop/files/measuringdrawers-sabrina-pantry-03192024-WH-2aweb.jpg?v=1711392696&width=900'
                }
                onClick={() => this.setState({ playing: true })}
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      showinfo: 0,
                    },
                  },
                  vimeo: {
                    playerOptions: {
                      responsive: true,
                    },
                  },
                }}
              />
            </figure>
            <ol>
              <li>
                <h4>
                  Measure the <u>INSIDE</u> of the drawer box.
                </h4>
                <ul>
                  <li>To help get a correct measurement of the drawer box, try measuring the inside, bottom part of the drawer box.</li>
                </ul>
              </li>
              <li>
                <h4>
                  Round <u>DOWN</u> to the nearest ½ inch measurement.
                </h4>
                <ul>
                  <li>
                    If your measurements are close to or exactly on the inch or half inch, round down to the nearest full half-inch to
                    ensure a proper fit.
                  </li>
                  <li>
                    For example, if your measurement is 19 3/4 “ round down to 19 ½”. If your measurement is 15” or just over 15” , round
                    down to 14 ½”.
                  </li>
                  <li>You do not need to round down on the height, assuming there is enough drawer clearance.</li>
                </ul>
              </li>
              <li>
                <h4>
                  Consider <u>OBSTRUCTIONS</u>.
                </h4>
                <ul>
                  <li>Do you have extra large drawer hardware screws? If so, you may want to round down an additional ½”.</li>
                  <li>
                    Does your countertop have a long overhang that covers a portion of the drawer? This may make it difficult to access the
                    back of the drawer. Consider an organizer configuration that doesn't have an isolated back compartment.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </ReactDrawer>
        <CollapsibleItem title="Shipping Times">{shippingLabel()}</CollapsibleItem>
      </div>
      <div className="benco-partnership">
        <figure>
          <img
            src="//salt-professional.myshopify.com/cdn/shop/files/Updated_Benco_Logo.png?v=1722886302"
            alt="In partnership with Benco Dental."
          />
        </figure>
        <h6>In partnership with Benco Dental.</h6>
      </div>
    </>
  );
};

export default ProductInfo;
